module.exports = __webpack_public_path__ + "static/media/PIL.3c4b8d4f.svg";